import React, { useState, useRef, useImperativeHandle } from "react";
import { Tooltip, theme } from "antd";
import { EditOutlined,  PlusCircleFilled,} from "@ant-design/icons";
import ErrorMessages from "../../common/ErrorMessages";
import TSTable from "../../common/TSTable";
import ColorButton from "../../common/ColorButton";
import {  currencyFormat, dateToHumanString, formatComma, } from "../../frameworks/Util";
import PurchaseCTTListViewModal from "./PurchaseCTTListViewModal";
import { URL_TANK } from "../../constants/urls";
import _ from 'lodash';
import CustomDeleteConfirmButton from "../../common/CustomDeleteConfirmButton";
import { DELETE } from "../../frameworks/HttpClient";

const PurchaseCTTListView = React.forwardRef((props, ref) => {
  const [openPurchaseCTTStockListView, setOpenPurchaseCTTStockListView] = useState(false);
  const [target, setTarget] = useState(null);
  const tableRef = useRef(null);
  const [errorMessages, setErrorMessages] = useState(null);

  const {
    token: { colorWarning, colorError, colorSuccess },
  } = theme.useToken();

  useImperativeHandle(ref, () => ({
    fetchTable: refreshData,
  }));

  const refreshData = async () => {
    if (tableRef.current) {
      setErrorMessages(null);
      try {
        await tableRef.current.fetchWithoutResetPage();
      } catch (error) {
        setErrorMessages(error.errorMessages);
      }
    }
  };
  const handleEdit = (record) => {
    if (!record || !record.id) {
      return;
    }
    setTarget(record);
    setOpenPurchaseCTTStockListView(true);
  };

  const handleDelete = async (id) => {
    if (!id) {
      return;
    }
    setErrorMessages(null);
    try {
      await DELETE(`${URL_TANK.IMPORT_CONCENTRATE_STOCK}${id}/`);
      refreshData();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    }
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 120,
      key: "action",
      align: "center",
      render: (_, record) =>
        (
          <div onClick={(e) => e.stopPropagation()}>
            <CustomDeleteConfirmButton
              onOk={ async() => {
                await handleDelete(record.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
            <Tooltip triger="hover" title="แก้ไขข้อมูล">
              <ColorButton
                type="primary"
                override={colorWarning}
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
                style={{ margin : 5 }}
              />
            </Tooltip>
          </div>
        ),
    },
    {
      title: "วันที่นำเข้า",
      dataIndex: "created",
      key: "created",
      align: "center",
      render : (value) => dateToHumanString(value)
    },
    {
      title: "ล็อตนำเข้า",
      dataIndex: "source_lot_no",
      key: "source_lot_no",
      align: "center",
      searcher : true,
    },
    {
      title: "Lot No.",
      dataIndex: "lot_no",
      key: "lot_no",
      align: "center",
      searcher : true,
    },
    {
      title: "บริษัทผู้นำเข้า",
      dataIndex: "supplier_name",
      key: "supplier_name",
      align: "center",
      searcher: true,
    },
    {
      title: "สินค้า", 
      dataIndex: "product_name",
      key: "product_name",
      align: "center",
      searcher : true,
    },
    {
      title: "น้ำหนัก",
      dataIndex: "weight",
      key: "weight",
      align: "center",
      render: (value) => <center>{formatComma(value)}</center>
    },
    {
      title: "%DRC",
      dataIndex: "drc",
      key: "drc",
      align: "center",
    },
    {
      title: "ราคา/กก.",
      dataIndex: "unit_price",
      key: "unit_price",
      align: "center",
    },
    {
      title: "ราคารวม",
      dataIndex: "net_price",
      key: "net_price",
      align: "center",
      render: (value) => <center>{currencyFormat(value ? value : 0)}</center>
    },
  ];

  return (
    <div>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
        type="primary"
        override={colorSuccess}
        icon={<PlusCircleFilled />}
        style={{ marginBottom: 10, float: "right" }}
        onClick={() => setOpenPurchaseCTTStockListView(true)}
      >
        นำเข้าน้ำยางข้น
      </ColorButton>
      <TSTable
        columns={columns}
        size="small"
        url={URL_TANK.IMPORT_CONCENTRATE_STOCK}
        ref={tableRef}
      />
      <PurchaseCTTListViewModal
        open={openPurchaseCTTStockListView}
        onClose={() => {
          setOpenPurchaseCTTStockListView(false);
          setTarget(null);
        }}
        onUpdate={() => {
          setOpenPurchaseCTTStockListView(false);
          setTarget(null);
          refreshData();
        }}
        target={target}
      />
    </div>
  );
});

export default PurchaseCTTListView;
